import { WindowEnv } from '../config/windowEnv.config';
import { FeatureFlags } from '../featureFlag/FeatureFlag.type';
import { isWindow } from './isWindow';

export type PartialWindow = Partial<Window & {
  __env: WindowEnv;
  __featureFlags: Partial<FeatureFlags>;
  dataLayer: unknown[];
}>;

export const safeWindow = (): PartialWindow => {
  if (isWindow()) {
    return window;
  }

  return {} as PartialWindow;
};
